import MasterChannel from './MasterChannel';
import SequenceChannel from './SequenceChannel';
import MidiBinder from './MidiBinder';

import { EventEmitter } from 'events';

class Song extends EventEmitter {

	constructor() {
		super();
		var channel;
		this.channels = [];
		for (var i = 0; i < 7; i++) {
			channel = new SequenceChannel(i);
			this.pipeEvent(channel, this, "SEQUENCE_QUEUED");
			this.pipeEvent(channel, this, "SEQUENCE_PLAYING");
			this.pipeEvent(channel, this, "REFRESH_SEQUENCES");
			this.channels.push(channel);
		}
		this.masterChannel = new MasterChannel();
		this.tempo = 128;
		this.key = "major";
		this.tonic = "C";
		this._id = undefined;
		this.can_save = false;
		this.selectedChannelNumber = 0;
		this.selectedSequenceNumber = 0;
		this.midi = new MidiBinder();
		this.name = "";
		this.visibility = 'public';

		this.getSelectedSequence().select()
	}

	pipeEvent(source, target, event) {
		source.on(event, (...payload) => {
			target.emit(event, ...payload);
		});
	}

	setTempo(tempo) {
		this.tempo = tempo;
	}

	getTempo() {
		return this.tempo;
	}

	rehydrate(state) {
		this.key = state.key || "major";
		this.tonic = state.tonic || "C";
		this.tempo = state.tempo || "128";
		this.name = state.name || "";
		this.masterChannel.rehydrate(state.masterChannel || {});
		for (var i = state.channels.length - 1; i >= 0; i--) {
			this.channels[i].rehydrate(state.channels[i] || {})
		};
		this._id = state._id;
		if(state.selected) {
			this.selectedChannelNumber = state.selected.channel;
			this.selectedSequenceNumber = state.selected.sequence;
		}
		this.getSelectedSequence().select();
		this.can_save = state.can_save;
		this.midi.rehydrate(state.midi || {});
		this.visibility = state.visibility || 'public';
	}

	dehydrate() {
		return {
			channels: this.channels.map(function(channel){
				return channel.dehydrate();
			}),
			masterChannel: this.masterChannel.dehydrate(),
			tempo: this.tempo,
			key: this.key,
			tonic: this.tonic,
			_id: this._id,
			selected: this.getSelected(),
			can_save: this.can_save,
			midi: this.midi.dehydrate(),
			name: this.name,
			visibility: this.visibility
		};
	}

	selectSequence(channel, sequence) {

		this.getSelectedSequence().deselect();

		this.selectedChannelNumber = channel;
		this.selectedSequenceNumber = sequence;

		this.getSelectedSequence().select()
	}

	getSelected() {
		return {
			channel: this.selectedChannelNumber,
			sequence: this.selectedSequenceNumber
		};
	}

	getSelectedChannel() {
		return this.channels[this.selectedChannelNumber];
	}

	getSelectedSequenceNoteNames() {
		return this.channels[this.selectedChannelNumber].instrument.getNotesNames(this.tonic, this.key);
	}

	getSelectedSequence() {
		return this.channels[this.selectedChannelNumber].sequences[this.selectedSequenceNumber];
	}

	resetTracksToZero() {
		this.channels.forEach((channel) => {
			var playing = channel.getPlayingSequence();
			if(playing !== false) {
				playing.currentPlayingBeat = 0;
			}
		});
	}

	isNew() {
		return typeof this._id === "undefined";
	}

	canUserSave() {
		return this.isNew() || this.can_save;
	}

}

export default Song;
